import { useGet } from './useHttpHooks';
import { Tag } from '../types';

type TagHierarchyQuery = { tagId: string };

const useGetTagHierarchy = (request: TagHierarchyQuery) =>
    useGet<Tag[]>(`/api/tags/${encodeURIComponent(request.tagId)}/hierarchy`, {
        errorMessage: 'GET /api/tags/{tagId}/hierarchy failed'
    });

export default useGetTagHierarchy;
